import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AppNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, hasRole } = useAuth();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  // Don't show navbar on login page
  if (location.pathname === '/login') {
    return null;
  }
  
  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/home">
          Data Vault
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={Link}
              to="/home"
              active={location.pathname === "/home"}
            >
              Home
            </Nav.Link>

            {/* Upload module - visible to makers and admins */}
            {(hasRole("maker") ||
              hasRole("admin") ||
              hasRole("cibil_uploader")) && (
              <NavDropdown
                title="Uploads"
                id="upload-dropdown"
                active={["/upload", "/csvs"].some((path) =>
                  location.pathname.includes(path)
                )}
              >
                {(hasRole("maker") || hasRole("admin")) && (
                  <NavDropdown.Item as={Link} to="/upload">
                    Upload New CSV
                  </NavDropdown.Item>
                )}
                {(hasRole("cibil_uploader") || hasRole("admin")) && (
                  <NavDropdown.Item as={Link} to="/cibil-upload">
                    Cibil Upload
                  </NavDropdown.Item>
                )}

                <NavDropdown.Item as={Link} to="/csvs">
                  View CSV Files
                </NavDropdown.Item>
              </NavDropdown>
            )}

            {/* Leads - visible to campaign managers and admins only */}
            {(hasRole("campaign_manager") || hasRole("admin")) && (
              <Nav.Link
                as={Link}
                to="/leads"
                active={location.pathname.includes("/leads")}
              >
                All Leads
              </Nav.Link>
            )}

            {/* Campaign module - visible to campaign managers and admins */}
            {(hasRole("campaign_manager") || hasRole("admin")) && (
              <Nav.Link
                as={Link}
                to="/campaigns"
                active={location.pathname.includes("/campaigns")}
              >
                Campaigns
              </Nav.Link>
            )}

            {/* Cibil Data Upload - visible to campaign managers and admins */}
            {user &&
              (user.role === "cibil_uploader" || user.role === "admin") && (
                <Nav.Link
                  as={Link}
                  to="/cibil-upload"
                  active={location.pathname.includes("/cibil-upload")}
                >
                  Cibil Upload
                </Nav.Link>
              )}

            {user &&
              (user.role === "campaign_manager" || user.role === "admin") && (
                <NavDropdown title="Campaigns" id="campaign-dropdown">
                  <NavDropdown.Item as={Link} to="/campaigns/new">
                    Create Campaign
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/campaigns">
                    All Campaigns
                  </NavDropdown.Item>
                </NavDropdown>
              )}

            {/* Add this inside the admin user dropdown or create admin section */}
            {user && user.role === "admin" && (
              <NavDropdown title="Admin" id="admin-dropdown">
                <NavDropdown.Item as={Link} to="/admin/users">
                  User Management
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/admin/mappings">
                  Column Mappings
                </NavDropdown.Item>
                <NavDropdown.Divider />
              </NavDropdown>
            )}
          </Nav>

          {user && (
            <Nav>
              <NavDropdown title={user.email} id="user-dropdown" align="end">
                <NavDropdown.Item as={Link} to="/profile">
                  Profile
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;